import {
  FaApple,
  FaSoundcloud,
  FaSpotify,
  FaYoutube,
  SiBeatport,
} from "@/components/icons";

export const platformIcons = {
  spotify: <FaSpotify size={19} color="black" />,
  soundcloud: <FaSoundcloud size={19} color="black" />,
  beatport: <SiBeatport size={19} color="black" />,
  youtube: <FaYoutube size={19} color="black" />,
  apple_music: <FaApple size={19} color="black" />,
};

export const lightPlatformIcons = {
  spotify: <FaSpotify size={19} />,
  soundcloud: <FaSoundcloud size={19} />,
  beatport: <SiBeatport size={19} />,
  youtube: <FaYoutube size={19} />,
  apple_music: <FaApple size={19} />,
};

export const platformNames = {
  spotify: "Listen on Spotify",
  soundcloud: "Listen on SoundCloud",
  beatport: "Listen on Beatport",
  youtube: "Listen on YouTube",
  apple_music: "Listen on Apple Music",
};
